import { User } from '../user/user';

export class UserGeneric extends User {
}
